import { render, staticRenderFns } from "./tags.vue?vue&type=template&id=18a64b33&scoped=true"
import script from "./tags.vue?vue&type=script&lang=js"
export * from "./tags.vue?vue&type=script&lang=js"
import style0 from "./tags.vue?vue&type=style&index=0&id=18a64b33&prod&rel=stylesheet%2Fscss&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a64b33",
  null
  
)

export default component.exports